import { Fragment } from "react";
import { fmtCLP } from "../../utils/formato";

export default function ConfirmPedidoModal({
  pedido,
  subtotal,
  totalFinal,
  descuento,
  cliente,
  telefono,
  canal,
  horaRetiro,
  medioPago,
  pagoDisplay,
  saldoPendiente = 0,
  pagado,
  observacion,
  trabajador = false,
  enviando,
  onConfirmar,
  onCancelar,
}) {
  return (
    <div className="modal">
      <div className="modal__dialog">
        <div className="modal__head">
          <h3 className="modal__title">{trabajador ? "Confirmar pedido de trabajador" : "Confirmar pedido"}</h3>
          <button
            className="modal__close"
            onClick={onCancelar}
            aria-label="Cerrar"
            title="Cerrar"
          >
            x
          </button>
        </div>

        <div className="modal__items">
          <div className="items-scroll">
            <table className="items-table items-table--compact">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Cant</th>
                  <th>Precio</th>
                  <th>Subtotal</th>
                </tr>
              </thead>
              <tbody>
                {(pedido ?? []).map((it) => {
                  const precio = Number(it.precio) || 0;
                  const cant = Number(it.cantidad) || 0;
                  const cambios = String(it.cambios || "").split(/\r?\n/).map((m) => m.trim()).filter(Boolean);
                  return (
                    <Fragment key={`${it.producto_id}-${it.nombre}`}>
                      <tr>
                        <td className="cell-name">{it.nombre}</td>
                        <td className="cell-center">{cant}</td>
                        <td className="cell-right">{fmtCLP(precio)}</td>
                        <td className="cell-right">{fmtCLP(precio * cant)}</td>
                      </tr>
                      {cambios.length > 0 && (
                        <tr>
                          <td colSpan={4} className="cell-mods">
                            <strong>Modificaciones:</strong>
                            <ul>
                              {cambios.map((m, idx) => (
                                <li key={`${m}-${idx}`}>{m.toUpperCase()}</li>
                              ))}
                            </ul>
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={3} className="cell-right foot-label">Subtotal</td>
                  <td className="cell-right">{fmtCLP(subtotal)}</td>
                </tr>
                {Number(descuento) > 0 && (
                  <tr>
                    <td colSpan={3} className="cell-right foot-label">Descuento</td>
                    <td className="cell-right">-{fmtCLP(descuento)}</td>
                  </tr>
                )}
                <tr>
                  <td colSpan={3} className="cell-right foot-label">Total</td>
                  <td className="cell-right foot-total">{fmtCLP(totalFinal)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <div className="modal__meta">
          <p><strong>Cliente:</strong> {cliente || "Sin nombre"}</p>
          {telefono && <p><strong>Telefono:</strong> {telefono}</p>}
          <p><strong>Canal:</strong> {canal}</p>
          <p><strong>Hora de Retiro:</strong> {horaRetiro || "No definida"}</p>
          {trabajador ? (
            <p><strong>Tipo:</strong> Trabajador</p>
          ) : (
            <>
              <p><strong>Medio de Pago:</strong> {pagoDisplay || medioPago}</p>
              <p><strong>Pagado:</strong> {pagado ? "Si" : "No"}</p>
            </>
          )}
          {Number(saldoPendiente) > 0 && (
            <p><strong>Saldo pendiente:</strong> {fmtCLP(saldoPendiente)}</p>
          )}
          {observacion && (
            <p className="modal__obs">
              <strong>Observacion:</strong> {observacion}
            </p>
          )}
        </div>

        <div className="modal__actions">
          <button className="btn" onClick={onCancelar} disabled={enviando}>
            Cancelar
          </button>
          <button className="btn btn-accent" onClick={onConfirmar} disabled={enviando}>
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
}
